// library imports
import { Flex } from "antd";
import { useEffect, useState, useContext } from "react";
// component imports
import ChatSender from "./middle/ChatSender";
import ChatBubbles from "./middle/ChatBubbles";
// function imports
import useCreateConversation from "../../functions/Conversation/createConversation";
import useAddChatHistory from "../../functions/ChatHistory/addChatHistory";
import useSendStreamingMcpClient from "../../functions/McpClient/sendStreamingMcpClient";
// context imports
import { IndexContext } from "../../context/IndexContext";

export default function ChatMiddle({
  activeConversation,
  chatHistoryList,
  changeConversation,
  historyLoading,
  handleRefreshConversation,
  handleRefreshHistory,
}) {
  const { siteSelected } = useContext(IndexContext);

  const [loading, setLoading] = useState(false);
  const [clearSender, setClearSender] = useState(false);

  const [debugMode, setDebugMode] = useState(false);
  const [deepThinking, setDeepThinking] = useState(false);

  const { createConversation } = useCreateConversation();
  const { addChatHistory } = useAddChatHistory();

  const {
    messages,
    setMessages,
    sendStreamingMcpClient,
    requestLoading,
    cancelFetchMcpClient,
  } = useSendStreamingMcpClient();

  // For handle sender result
  function handleSend(value, fileList) {
    let formData = new FormData();
    fileList.forEach((file) => {
      formData.append(`${file["name"]}`, file["originFileObj"]);
    });
    formData.append("response", value);

    if (activeConversation == null) {
      // Create new conversation and chat history
      createConversation(formData, setLoading, handleConversationSuccess);
    } else {
      formData.append("conversation_id", activeConversation);
      // Creat new chat history
      addChatHistory(formData, setLoading, handleHistorySuccess);
    }
  }
  function handleCancel() {
    // setLoading(false);
  }

  // For handle after create conversation and chat history success
  function handleConversationSuccess(conversationKey) {
    handleRefreshConversation(conversationKey);
  }

  // For handle after create chat histroy success
  function handleHistorySuccess() {
    handleRefreshHistory();
    setClearSender(true);
  }

  function handleSendSuccess() {
    handleRefreshHistory();
  }

  function handleDebugThinking(value, type) {
    if (type == "thinking") {
      setDeepThinking(value);
      if (value) setDebugMode(false);
    } else if (type == "debug") {
      setDebugMode(value);
      if (value) setDeepThinking(false);
    }
  }

  // For clear sender value when user change active conversation
  useEffect(() => {
    setClearSender(true);
  }, [activeConversation]);

  useEffect(() => {
    if (chatHistoryList.length > 0) {
      let lastItem = chatHistoryList.at(-1);
      if (lastItem["status"] == 1 && lastItem["role"] == "user") {
        sendStreamingMcpClient({
          message: undefined,
          messages: [],
          conversationKey: activeConversation,
          historyKey: chatHistoryList.at(-1)["key"],
          thinking: deepThinking,
          debug: debugMode,
          site_id: siteSelected,
          handleSendSuccess: () => handleSendSuccess(),
        });
      }
    }
  }, [chatHistoryList]);

  // For handle bubble items and typing effect
  useEffect(() => {
    if (chatHistoryList.length > 0) {
      let updateList = chatHistoryList.map((item, index) => {
        let defaultDict = {
          id: item.key,
          message: item.role != "file" ? item.content : undefined,
          status: item.role == "user" ? "local" : "success",
          footer: item.footer,
          thinking: item.thinking,
        };
        if (index == chatHistoryList.length - 1 && item["role"] == "ai") {
          defaultDict["typing"] = { step: 5, interval: 5 };
        }
        if (item.role == "file") defaultDict["file"] = item.content;

        return defaultDict;
      });

      setMessages(updateList);
    } else {
      setMessages(chatHistoryList);
    }
  }, [chatHistoryList]);

  useEffect(() => {
    cancelFetchMcpClient();
  }, [activeConversation]);

  return (
    <Flex
      vertical="vertical"
      justify="space-between"
      style={{ height: "100%", maxHeight: "82vh" }}
      gap={"middle"}
    >
      <ChatBubbles
        messageList={messages}
        historyLoading={historyLoading}
        changeConversation={changeConversation}
        handleRefreshHistory={handleRefreshHistory}
        handleSend={handleSend}
      />
      <ChatSender
        loading={requestLoading || loading}
        handleSend={handleSend}
        handleCancel={handleCancel}
        clearSender={clearSender}
        setClearSender={setClearSender}
        deepThinking={deepThinking}
        debugMode={debugMode}
        handleDebugThinking={handleDebugThinking}
      />
    </Flex>
  );
}
